export const LD_CLIENT_INITIALIZATION_TIMEOUT_SECONDS = 15;
